module.exports = "https://cdn.realtymogul.com/static/media/img_leftpanel.855e06ba.jpg";